<!--在左侧的聊天消息-->
<template>
	<div class="infoBody" :class="{leftInfoBody:!isRightPart}">
		<div class="picPart" v-if="!isRightPart">
			<!--左侧头像-->
			<img :src="headPic">
		</div>
		<div :class="{leftMsgPart:!isRightPart,rightMsgPart:isRightPart}">
			<p class="nameP">{{userName}}</p>
			<span class="msgSpan" v-if="imgPath != undefined"><img :src="imgPath" @click="showBigImage = true"></span>
			<span class="msgSpan fileDownload" v-else-if="filePath != undefined">
				<img class="fileIcoImage" :src="getFileIcoPath(fileIcoPath)">
				<u title="下载文件" @click="saveAs(filePath,getFileName(filePath))">{{getFileName(filePath)}}</u>
			</span>
			<span v-else-if="messageType == 'location'">
				<chatMap :point="messageBody" :index="index"></chatMap>
			</span>
			<span class="msgSpan" v-else>{{messageBody}}</span>
		</div>
		<div class="picPart" v-if="isRightPart">
			<!--右侧头像-->
			<img :src="headPic">
		</div>
		<div class="dialog-window" v-if="imgPath != undefined && showBigImage" @click="showBigImage = false">
			<div class="dialog-body" style="height: 90%;overflow: hidden;" @click.stop="">
				<div class="button-line">
					<img :src="getResourcesByName('/chat/ico_download.svg')" class="button-img" @click="saveAs(imgPath)" title="下载">
					<img :src="getResourcesByName('/wedoButton/close.png')" class="button-img" @click="showBigImage = false" title="关闭">
				</div>
				<div class="custom-scrollbar" style="overflow: auto;height: 100%;">
					<img :src="imgPath" style="width: 100%;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import chatMap from './chatMap.vue'
	export default {
		components: {
			chatMap
		},
		props: {
			index: {
				type: Number
			},
			messageType: {
				type: String
			},
			isRightPart: {
				type: Boolean,
				default: false
			},
			headPic: {
				type: String,
				default: resourcesStore.getters.getResourcesByName('/unitInfo/circle_bg.png')
			},
			userName: {
				type: String
			},
			messageBody: {
				type: String
			},
			imgPath: {
				type: String
			},
			filePath: {
				type: String
			},
			fileIcoPath: {
				type: String
			}
		},
		data() {
			return {
				showBigImage: false
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getFileIcoPath() {
				return icoPath => {
					if (icoPath != undefined) {
						return resourcesStore.getters.getResourcesByName(icoPath)
					}
				}
			},
			getFileName() {
				return filePath => {
					if (filePath == undefined) {
						return
					}
					return filePath.substr(filePath.lastIndexOf('/') + 1)
				}
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			},
			getLng() {
				return point => {
					var point = JSON.parse(point)
					return point.lng
				}
			}
		},
		watch: {},
		methods: {
			saveAs(filePath,fileName){
				saveAs(filePath,fileName)
			}
		}
	}
</script>

<style scoped>
	@import url("../../css/dialog.css");

	.infoBody {
		display: flex;
		align-items: flex-start;
		justify-content: flex-end;
	}

	.infoBody.leftInfoBody {
		justify-content: flex-start;
	}

	.picPart {
		padding: 10px;
	}

	.picPart>img {
		width: 50px;
		height: 50px;
	}

	.nameP {
		padding: 10px 0;
		color: #C0C0C0;
	}

	.rightMsgPart>.nameP {
		text-align: right;
	}

	.rightMsgPart>.msgSpan {
		word-break: break-all;
		word-wrap: break-word;
		text-align: left;
		position: relative;
		display: inline-block;
		font-size: 15px;
		padding: 10px 15px;
		line-height: 20px;
		min-width: 9px;
		min-height: 18px;
		-webkit-border-radius: 20px 0 20px 20px;
		border-radius: 20px 0 20px 20px;
		color: #fff;
		background: -webkit-linear-gradient(70deg, #3FD1E1 0%, #44D7CD 100%);
		background: linear-gradient(20deg, #3f8fe1cc 0%, #44d7c9 100%);
		-webkit-box-shadow: 5px 5px 15px 0 rgba(102, 102, 102, 0.15);
		box-shadow: 5px 5px 15px 0 rgba(102, 102, 102, 0.15);
	}

	.leftMsgPart>.msgSpan {
		word-break: break-all;
		word-wrap: break-word;
		text-align: left;
		position: relative;
		display: inline-block;
		font-size: 15px;
		padding: 10px 15px;
		line-height: 20px;
		min-width: 9px;
		min-height: 18px;
		border-radius: 0 20px 20px 20px;
		color: #666;
		border: 1px solid rgba(0, 0, 0, 0.05);
		background: #FFF;
		-webkit-box-shadow: 5px 5px 15px 0 rgba(102, 102, 102, 0.1);
		box-shadow: 5px 5px 15px 0 rgba(102, 102, 102, 0.1);
	}

	.msgSpan>img {
		width: 150px;
		height: auto;
		cursor: pointer;
	}

	.msgSpan>img.fileIcoImage {
		width: 40px;
		height: 40px;
		margin-bottom: 10px;
	}

	.msgSpan.fileDownload {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	.msgSpan.fileDownload>u {
		color: white;
		cursor: pointer;
	}

	.msgSpan.fileDownload>u:hover {
		color: blue;
	}
</style>
